export const frontendDiagnosticsEvents = {
  adminExtension: {
    registered: 'extension_registered',
    disposed: 'extension_disposed',
    collisionBlocked: 'extension_collision_blocked',
    invalidRegistration: 'invalid_extension_registration',
    routeResolutionFailed: 'route_resolution_failed',
    diagnosticsListenerFailed: 'admin_extension_diagnostics_listener_failed',
    lifecycleListenerFailed: 'admin_extension_lifecycle_listener_failed',
    registryInvalidationListenerFailed: 'admin_extension_registry_invalidation_listener_failed',
  },
  blockExtension: {
    registered: 'block_extension_registered',
    disposed: 'block_extension_disposed',
    collisionBlocked: 'block_extension_collision_blocked',
    invalidRegistration: 'invalid_block_extension_registration',
    registrationFailed: 'plugin_block_extension_registration_failed',
    disposeFailed: 'plugin_block_extension_dispose_failed',
    cacheInvalidated: 'block_runtime_cache_invalidated',
    runtimeRenderFailed: 'block_runtime_render_failed',
  },
  pluginRuntime: {
    preflightFailed: 'plugin_runtime.render_block_preflight_failed',
    renderFailed: 'plugin_runtime.render_block_failed',
    render422: 'plugin_runtime.render_block_422',
  },
  storefrontRuntime: {
    rendered: 'storefront_plugin_runtime_rendered',
    failed: 'storefront_plugin_runtime_failed',
    fallback: 'storefront_plugin_runtime_fallback',
    timeout: 'storefront_plugin_runtime_timeout',
    invalidPayload: 'storefront_plugin_runtime_invalid_payload',
  },
} as const
